var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 16.6667C32.8611 16.6667 32.4653 16.507 32.1458 16.1875C31.8264 15.8681 31.6667 15.4723 31.6667 15C31.6667 14.5278 31.8264 14.132 32.1458 13.8125C32.4653 13.4931 32.8611 13.3334 33.3333 13.3334C33.8056 13.3334 34.2014 13.4931 34.5208 13.8125C34.8403 14.132 35 14.5278 35 15C35 15.4723 34.8403 15.8681 34.5208 16.1875C34.2014 16.507 33.8056 16.6667 33.3333 16.6667ZM16.6667 36.6667V30.6667L12.3333 35L10 32.6667L16.6667 26V23.3334H14L7.33334 30L5 27.6667L9.33334 23.3334H3.33334V20H9.33334L5 15.6667L7.33334 13.3334L14 20H16.6667V17.3334L10 10.6667L12.3333 8.33337L16.6667 12.6667V6.66671H20V12.6667L24.3333 8.33337L26.6667 10.6667L20 17.3334V20H33.3333V23.3334H27.3333L31.6667 27.6667L29.3333 30L22.6667 23.3334H20V26L26.6667 32.6667L24.3333 35L20 30.6667V36.6667H16.6667ZM31.6667 11.6667V3.33337H35V11.6667H31.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherCold);
export default __webpack_public_path__ + "static/media/weather-cold.72a2d437b2a03cd105cf6d720cfe4553.svg";
export { ForwardRef as ReactComponent };